import store from '@/pages/index/store'
// window.addEventListener('message', receiveMessageHandler)

window.$$messageManage = receiveMessageHandler

function receiveMessageHandler (data) {
  if (!data.type) return
  if (!handler[data.type]) return
  handler[data.type](data)
}

const handler = {
  closeDetailPage: () => {
    store.commit('updateCalendarParams', {})
    store.commit('updateTodoTask', Date.now())
  },
  // ilaw计时发生变化的时候，需要更新V5中计时的内容
  changeTiming: data => store.commit('TIMING_SYNC_START', data.content)
}
